<template>
  <div class="modal">
    <div class="modal-wrap" v-click-outside="closeModel">
      <ModalInfoV2
        @emailError="emailError"
        @otherKits="showModel"
        @sendProp="sendProp"
        @editData="editData"
        ref="componentA"
        :show="modelKits"
        :showEdit="showEdit"
      ></ModalInfoV2>
      <ModalDescV2
        v-show="modelKits === false"
        :emailErrorObj="emailErrorObj"
        :personalData="personalData"
        @enableEdit="enableEdit"
        @closeModal="closeModal"
        @showComment="showComment"
        :validationError="validationError"
      ></ModalDescV2>
      <transition>
        <ModalKitsV2
          v-if="modelKits === true"
          @closeModal="closeModal"
          @changeDescModal="changeDescModal"
        ></ModalKitsV2>
      </transition>
      <CommentOnHold
        v-if="showCommentModal"
        @closeConfurmHoldTxt="closeConfurmHoldTxt"
        :txtOnHold="txtOnHold"
        :isV2="true"
      ></CommentOnHold>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ModalInfoV2 from "./ModalInfoV2";
import ModalDescV2 from "./ModalDescV2";
import ModalKitsV2 from "./ModalKitsV2";
import CommentOnHold from "../../components/dashboard/CommentOnHold";

export default {
  name: "ModalV2",
  data() {
    return {
      modelKits: false,
      showCommentModal: false,
      emailErrorObj: {},
      txtOnHold: "",
      personalData: {
        firstName: "",
        lastName: "",
        email: ""
      },
      validationError: false,
      showEdit: false
    };
  },
  components: {
    ModalInfoV2,
    ModalDescV2,
    ModalKitsV2,
    CommentOnHold
  },
  methods: {
    ...mapActions(["setTestKitInfoV2"]),
    closeModel() {
      // Clear V2 kit info
      this.$store.commit("setTestKitInfoV2", null);
      this.$store.commit("setUserInfoV2", null);
      this.$emit("closeModal", false);
    },
    enableEdit(obj) {
      this.showEdit = obj;
    },
    emailError(error) {
      this.emailErrorObj = error;
    },
    showComment(obj) {
      this.showCommentModal = obj.show;
      this.txtOnHold = obj;
    },
    showModel(boolean) {
      this.modelKits = boolean;
    },
    closeModal(boolean) {
      this.$emit("closeModal", boolean);
    },
    changeDescModal(boolean) {
      this.modelKits = boolean;
    },
    closeConfurmHoldTxt(boolean) {
      this.showCommentModal = boolean;
    },
    sendProp(data) {
      this.personalData = data;
    },
    editData(data) {
      this.personalData = data;
    }
  },
  created() {
    const kitInfo = this.$store.getters.getTestKitInfoV2;
    if (kitInfo) {
      this.personalData.firstName = kitInfo.collected_first_name;
      this.personalData.lastName = kitInfo.collected_last_name;
      this.personalData.email = kitInfo.collected_email;
    }
  }
};
</script>

<style scoped>
.modal {
  width: 100%;
  height: 100%;
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-wrap {
  border-radius: 10px;
  height: 750px;
  min-width: 1350px;
  display: flex;
}
@media (max-height: 790px) {
  .modal-wrap {
    height: 690px;
  }
}
</style>
